import MeterV2ListPresenter from "./MeterV2ListPresenter";
import MeterV2SearchPresenter from "./MeterV2Search/MeterV2SearchPresenter";

export const MeterV2List = {
    List: MeterV2ListPresenter,
    InputSearch: MeterV2SearchPresenter,
}

export default MeterV2ListPresenter;

